const { YES } = require("../constants/formula");

const calculateSIP = ({ input1, input2, input3 }) => {
  // End amount |A| = Amount entered for period |B| x {[(1+ interest rate|i|/no. Of periods)^(no. Of years|t|*no. Of periods) - 1]/interest rate/no. Of periods}*(1+Interest rate/no. Of periods)

  const principal = parseFloat(input1);
  const rate = parseFloat(input2) / 100 / 12;
  const years = parseFloat(input3) * 12;
  const futureValue =
    principal *
    ((Math.pow(1 + rate, years) - 1) / rate) *
    (1 + rate);
  const totalInvestedValue = principal * years;
  const estimatedReturns = futureValue - totalInvestedValue;
  return {
    output1: totalInvestedValue,
    output2: Math.round(estimatedReturns),
    output3: Math.round(futureValue),
  };
};

const calculateLumpsum = ({ input1, input2, input3 }) => {
  // Present value of amount |PV| * (1+ interest rate|i|)^(Time in years|t|)

  const principal = parseFloat(input1);
  const rate = parseFloat(input2) / 100;
  const years = parseFloat(input3);
  const futureValue = principal * Math.pow(1 + rate, years);
  const estimatedReturns = futureValue - principal;
  return {
    output1: principal,
    output2: Math.round(estimatedReturns),
    output3: Math.round(futureValue),
  };
};

function calculateHRA({
  input1,
  input2,
  input3,
  input4,
  input5,
}) {
  const basicSalary = parseFloat(input1);
  const actualHRA = parseFloat(input2);
  const dailyAllowance = parseFloat(input3);
  const rentPaid = parseFloat(input4);
  const isMetro = input5 === YES;

  const salary = basicSalary + dailyAllowance;
  const metroFractionalValue = isMetro ? 0.5 : 0.4;

  const hraExemption = Math.min(
    actualHRA,
    Math.max(0, rentPaid - 0.1 * salary),
    metroFractionalValue * salary
  );

  const taxableHRA = actualHRA - hraExemption;

  return {
    output1: Math.max(0, hraExemption),
    output2: Math.max(0, taxableHRA),
  };
}

function calcPercentage(minValue, maxValue, inputValue) {
  return (
    ((inputValue - minValue) * 100) / (maxValue - minValue)
  );
}

module.exports = {
  calcPercentage,
  calculateHRA,
  calculateLumpsum,
  calculateSIP,
};
